import React from 'react';
import styles from '../GuidanceCard.scss';
import { Bone, Skeleton } from '@xo-union/tk-ui-skeleton';
import { formatCounterValue } from './counterHelper';
import snakeCase from 'lodash/snakeCase';
import { useWwsViewCountQuery } from '../../../../generated/graphql';
interface BoxCounterProps {
  value: number;
  description: string;
}

const ViewCounter = ({ value, description }: BoxCounterProps) => {
  const { loading } = useWwsViewCountQuery();

  return (
    <div className={styles.counterContainer}>
      <div className={styles.counterNumber}>
        {!loading ? (
          formatCounterValue(value)
        ) : (
          <Skeleton aria-label={`loading view count`} data-testid={`loading_${snakeCase(description)}`}>
            <Bone style={{ height: 26, width: 40, marginBottom: 2 }} />
          </Skeleton>
        )}
      </div>
      <div className={styles.counterCaption}>{description}</div>
    </div>
  );
};

export default ViewCounter;
